import { buildTrackingParams, trackRetailerProductPageEvent } from "./analytics.js";
import { buildAppInstallationInfo, getBrowserPlatformManifest, getDeviceIdAsync, getInstallationId } from "./appInstallationBuilder.js";
import { getAppConsistentParams } from "./appUtils.js";
import { BC_MEDIA_DOMAIN, BC_TESTIMONIALS, BC_VIDEOS, getAssetNameFromUrl, getBrandLogo, getDefaultBrandclubImage, getDefaultProductImage, getEntityImage, getFallbackBrandclubImage, getFallbackProductImage, getFeaturedRetailerImage, getImageAssetUrl } from "./assetUtils.js";
import { default as default2 } from "./brandclubStoreConfigUtils.js";
import { formatRewardAmount, getBrandIds } from "./brandUtils.js";
import { BrandclubCheckoutBroadcast, BroadCastMessage } from "./broadcast.js";
import { getBuyOrViewProductMetaTag } from "./dataLayer.js";
import { formatPhoneNumber } from "./formatPhoneNumber.js";
import { isCampaignType } from "./isCampaignType.js";
import { calculateElementFontShift, useOpticalFontCenter } from "./opticalFontCenter.js";
import { buildRewardList, getAddToBagText, getProductPageRewards, getProductUrl, getPurchaseRewardAmountForProduct, getPurchaseRewardAmountForProductV2, getRewardTextFromCampaignType, getSortedBuyBoxProducts, isProductEligibleForCheckout, isProductOutOfStock, isServerSideCheckoutEligible } from "./productUtils.js";
import { getStorageWithExpiry, removeStorageWithExpiry, setStorageWithExpiry } from "./storage.js";
import { BRANDCLUB_SHOPIFY_RETAILERS, changeAmazonImageUrlResolution, decodeHTMLCharacters, escapeUriPath, formatMoney, getContrastColor, getNumericValue, getRetailerFromId, getRootFontSize, isParentProduct, isShopifyProduct, isWhite, parseThemeUrl, pxToRem, remToPx, removeTrailingSlash, roundFloat } from "./stringUtils.js";
import { sendTextCallback } from "./textMessage.js";
import { checkAndAppendRoutePrefixToLink, extractSKUFromWidgets } from "./widgetUtils.js";
import { filterShallowUndefinedObjectEntries } from "./objectUtils.js";
import { Logger } from "./logger.js";
import { sumAllItemQuantities, sumItemQuantities } from "./checkout.js";
import { BRANDCLUB_APP_CONFIG_ID, BRANDCLUB_BRAND_ID, BRANDCLUB_BRAND_NAME, BRANDCLUB_RETAILERS, DEFAULT_LINK_ID, DESKTOP_HORIZONTAL_PADDING, DESKTOP_SCREEN_SIZE, DIALOG_SCREEN_SIZE, MOBILE_HORIZONTAL_PADDING, MOBILE_SCREEN_SIZE, PLACEHOLDER_GREEN_IMAGE, SMALL_MOBILE_SCREEN_SIZE, SMALL_TABLET_SCREEN_SIZE, TABLET_HORIZONTAL_PADDING, TABLET_SCREEN_SIZE, UNIVERSAL_STORE_SITE, WIDGET_MEDIA_BORDER_RADIUS, WIDGET_PAIR_PRODUCT_PADDING, WIDGET_SPACE, WIDGET_SPACE_HALF, XL_DESKTOP_SCREEN_SIZE } from "./constants/Constants.js";
import { useConversationStarters } from "./hooks/useConversationStarters.js";
import { useDebouncedCallback } from "./hooks/useDebouncedCallback.js";
import { useDelayedRedirect } from "./hooks/useDelayedRedirect.js";
import { useIsConciergeEnabled } from "./hooks/useIsConciergeEnabled.js";
import { useJoinBrandClub, useJoinBrandClubWithRedirect } from "./hooks/useJoinBrandClub.js";
import { useLocationParams } from "./hooks/useLocationParams.js";
import { useOverflow } from "./hooks/useOverflow.js";
import { useStateWithDep } from "./hooks/useStateWithDep.js";
const isCrossDomainUrl = (targetUrl) => {
  try {
    const target = typeof targetUrl === "string" ? new URL(targetUrl) : targetUrl;
    const current = new URL(window.location.href);
    return target.hostname !== current.hostname;
  } catch (e) {
    console.error("Invalid URL for cross-domain check:", e);
    return false;
  }
};
export {
  BC_MEDIA_DOMAIN,
  BC_TESTIMONIALS,
  BC_VIDEOS,
  BRANDCLUB_APP_CONFIG_ID,
  BRANDCLUB_BRAND_ID,
  BRANDCLUB_BRAND_NAME,
  BRANDCLUB_RETAILERS,
  BRANDCLUB_SHOPIFY_RETAILERS,
  BrandclubCheckoutBroadcast,
  default2 as BrandclubStoreConfigUtils,
  BroadCastMessage,
  DEFAULT_LINK_ID,
  DESKTOP_HORIZONTAL_PADDING,
  DESKTOP_SCREEN_SIZE,
  DIALOG_SCREEN_SIZE,
  Logger,
  MOBILE_HORIZONTAL_PADDING,
  MOBILE_SCREEN_SIZE,
  PLACEHOLDER_GREEN_IMAGE,
  SMALL_MOBILE_SCREEN_SIZE,
  SMALL_TABLET_SCREEN_SIZE,
  TABLET_HORIZONTAL_PADDING,
  TABLET_SCREEN_SIZE,
  UNIVERSAL_STORE_SITE,
  WIDGET_MEDIA_BORDER_RADIUS,
  WIDGET_PAIR_PRODUCT_PADDING,
  WIDGET_SPACE,
  WIDGET_SPACE_HALF,
  XL_DESKTOP_SCREEN_SIZE,
  buildAppInstallationInfo,
  buildRewardList,
  buildTrackingParams,
  calculateElementFontShift,
  changeAmazonImageUrlResolution,
  checkAndAppendRoutePrefixToLink,
  decodeHTMLCharacters,
  escapeUriPath,
  extractSKUFromWidgets,
  filterShallowUndefinedObjectEntries,
  formatMoney,
  formatPhoneNumber,
  formatRewardAmount,
  getAddToBagText,
  getAppConsistentParams,
  getAssetNameFromUrl,
  getBrandIds,
  getBrandLogo,
  getBrowserPlatformManifest,
  getBuyOrViewProductMetaTag,
  getContrastColor,
  getDefaultBrandclubImage,
  getDefaultProductImage,
  getDeviceIdAsync,
  getEntityImage,
  getFallbackBrandclubImage,
  getFallbackProductImage,
  getFeaturedRetailerImage,
  getImageAssetUrl,
  getInstallationId,
  getNumericValue,
  getProductPageRewards,
  getProductUrl,
  getPurchaseRewardAmountForProduct,
  getPurchaseRewardAmountForProductV2,
  getRetailerFromId,
  getRewardTextFromCampaignType,
  getRootFontSize,
  getSortedBuyBoxProducts,
  getStorageWithExpiry,
  isCampaignType,
  isCrossDomainUrl,
  isParentProduct,
  isProductEligibleForCheckout,
  isProductOutOfStock,
  isServerSideCheckoutEligible,
  isShopifyProduct,
  isWhite,
  parseThemeUrl,
  pxToRem,
  remToPx,
  removeStorageWithExpiry,
  removeTrailingSlash,
  roundFloat,
  sendTextCallback,
  setStorageWithExpiry,
  sumAllItemQuantities,
  sumItemQuantities,
  trackRetailerProductPageEvent,
  useConversationStarters,
  useDebouncedCallback,
  useDelayedRedirect,
  useIsConciergeEnabled,
  useJoinBrandClub,
  useJoinBrandClubWithRedirect,
  useLocationParams,
  useOpticalFontCenter,
  useOverflow,
  useStateWithDep
};
//# sourceMappingURL=index.js.map
